import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-perimeterx-modal',
  styleUrl: 'ugc-perimeterx-modal.scss',
  shadow: false,
})
export class UgcPerimeterxModal {
  handleCancel() {
    const el = document.querySelector('.perimeterx-modal #px-captcha');
    if (el) {
      el.innerHTML = '';
    }
    state.isShowPerimeterx = false;
  }

  render() {
    const {
      qnaStaticLanguage: { IDS_UGC_PERIMETERX_IDENTITY_TITLE },
      reviewStaticLanguage: { IDS_UGC_PERIMETERX_IDENTITY_TITLE: IDS_UGC_PERIMETERX_IDENTITY_TITLE_REVIEW },
      isShowPerimeterx,
    } = state;

    return (
      <ugc-drawer
        isShow={isShowPerimeterx}
        modalTitle={IDS_UGC_PERIMETERX_IDENTITY_TITLE || IDS_UGC_PERIMETERX_IDENTITY_TITLE_REVIEW}
        isShowButton={false}
        isShowCloseButton={false}
        disabledBackDropClick
        handleCancel={this.handleCancel.bind(this)}
        zIndex={modalZIndex['ugc-px-modal']}
      >
        {isShowPerimeterx && (
          <div class="perimeterx-modal flex-row-center-center">
            <div id="px-captcha" class="flex-col-center-center" />
          </div>
        )}
      </ugc-drawer>
    );
  }
}
